import { animate, style, transition, trigger } from "@angular/animations";

export const expandCollapse = trigger('expandCollapse', [
  transition(':enter', [
    style({ height: 0, opacity: 0, overflow: 'hidden' }),
    animate('0.3s ease-in-out', style({ height: '*', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ overflow: 'hidden' }),
    animate('0.3s ease-in-out', style({ height: 0, opacity: 0 }))
  ])
])